
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/men",
      function () {
        return require("private-next-pages/men.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/men"])
      });
    }
  